import React from 'react'
import { SvgIcon } from './SvgIcon'

interface Props {
  className?: string
}

export function Info({ className }: Props) {
  return (
    <SvgIcon className={className} viewBox="0 0 30 30" fill="currentColor">
      <path d="M30,15A15,15,0,1,1,15,0,15,15,0,0,1,30,15ZM16.5,9V6h-3V9Zm0,15V12h-3V24Z" fillRule="evenodd" />
    </SvgIcon>
  )
}
